module.exports = __webpack_public_path__ + "static/media/email.aa879503.png";